import React from "react";
import I18n from "../../../../commons/I18n/I18n";
import Vehicle from "../../../../commons/model/Vehicle";
import { generateRoute } from "../../../../commons/utils/Router";
import ActiveLabel from "../../../../components/label/ActiveLabel";
import Th from "../../../../components/table/Th";
import I18nKeys from "../../../../I18n/I18nKeys";
import { ROUTE_COMPANY_USER_VEHICLE_DETAIL } from "../../../../routing/Routes";
import { goToRoute } from "../../../../utils/Router";
import { OnSortHandler, SortState } from "../../../../utils/Sort";

interface VehicleListTableProps {
    data: Vehicle[];
    error: string;
    onSort: OnSortHandler;
    sort: SortState;
    renderSelectTd?: (itemId: string)=> React.ReactNode;
}

const goToItemDetail = (itemId: string): void => {
  goToRoute(generateRoute(ROUTE_COMPANY_USER_VEHICLE_DETAIL, {
    id: itemId,
  } ));
};

export default class VehicleListTable extends React.Component<VehicleListTableProps> {
  public render(): React.ReactNode {
    const {data, renderSelectTd} = this.props;

    return (
      <table className="table table-hover">
        <thead>{this.renderTH()}</thead>
        <tfoot>{this.renderTH()}</tfoot>
        <tbody>
          {data && data.map((vehicle: Vehicle) => (
            <tr key={vehicle.id}
              onClick={() => goToItemDetail(vehicle.id)}
              className={"tr-cursor"}
            >
              {renderSelectTd ? renderSelectTd(vehicle.id) : null}
              <td>
                {vehicle.license_plate}
              </td>
              <td>
                {vehicle.license_plate_mask ? vehicle.license_plate_mask.name : ""}
              </td>
              <td>
                <ActiveLabel text={vehicle.special ? I18n.tr(I18nKeys.SI) : I18n.tr(I18nKeys.NO)}
                  active={vehicle.special}
                />
              </td>
              <td>
                {vehicle.vehicle_model?.vehicle_brand?.name ?? ""}
              </td>
              <td>
                {vehicle.vehicle_model ? vehicle.vehicle_model.name : ""}
              </td>
              <td>
                {vehicle.vehicle_type ? vehicle.vehicle_type.name : ""}
              </td>
              <td>
                {vehicle.vehicle_color ? vehicle.vehicle_color.name : ""}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  private renderTH(): React.ReactNode {
    const {sort, children, onSort} = this.props;
    const commonProps = {
      sort,
      onSort,
    };

    return (
      <tr>
        {children}
        <Th text={I18n.tr(I18nKeys.MATRICULA)}
          columnName={"license_plate"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.MASCARA)}
          columnName={"license_plate_mask"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.ESPECIAL)}
          columnName={"special"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.MARCA)}
          columnName={"vehicle_brand"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.MODELO)}
          columnName={"vehicle_model"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.TIPO)}
          columnName={"vehicle_type"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.COLOR)}
          columnName={"vehicle_color"}
          {...commonProps}
        />
      </tr>
    );
  }
}
